import { UPDATE_AID_YEAR, FETCH_INTERVIEW_TYPES_ALL } from "./types";
import history from "../history";
import InterviewService from "../services/InterviewService";
import { fetchIsirRecElementInfo } from "../actions/AdminActions";

export const updateAidYear = (aidYear, path, forceRedirect) => {
  return dispatch => {
    dispatch(fetchIsirRecElementInfo(aidYear));
    dispatch(fetchAllInterviewTypes(aidYear));
    dispatch({ type: UPDATE_AID_YEAR, payload: aidYear });

    if (!forceRedirect) {
      if (path) {
        history.push(path)
      } else if (window.location.href.toString().toLowerCase().includes("studentview")) {
        history.push("/userSearch");
      }
    }
  };
};

export const fetchAllInterviewTypes = (aidYear) => {
  return async dispatch => {
    const response = await InterviewService.getAllInterviewTypesWithRevisions(aidYear);
    dispatch({ type: FETCH_INTERVIEW_TYPES_ALL, payload: response });
  };
};
